import { PAYMENT_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };

export const usePaymentUserUnsettledPaymentAPI = () => {
  const configuration = useConfiguration();
  const [unsettledPayment,setUnsettledPayment]=useState([])

  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  // isCustomerWalletDetailsInProgress
  const execute = useCallback(
    async (userId: string) => {
      try {
       
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .get(`${PAYMENT_MODULE?.USER_UNSETTLED_DETAILS_API?.baseURL}${userId}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true) {
              setUnsettledPayment(res.data?.data)
             
              return { status: true, message: "Cart Level Coupons Fetched" };
            } else {
             setUnsettledPayment([])
            
              return { status: false, message: "No Cart Level Coupons" };
            }
          })
          .catch((e: AxiosError) => {
          setUnsettledPayment([])
            sendCurl(e.config["curlCommand"]);
            captureError(e);
          
            return { status: false, message: "cart_not_filtered" };
          });
        return response;
      } catch (e: any) {
        setUnsettledPayment([])
      
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute ,unsettledPayment};
};
